import { IProject, IScene } from '@/helpers/editor';
import HttpHelper from '@/helpers/http';

interface IProjectResponse {
  success: boolean;
  projects?: IProject[];
  project?: IProject;
  message?: string;
}

interface ISceneResponse {
  success: boolean;
  scene: IScene | IScene[];
  message?: string;
}

export default class ProjectApi {
  static async getProjects(): Promise<IProjectResponse> {
    return await HttpHelper.authGet('/api/v1/users/projects');
  }

  static async getProject(id: string): Promise<IProjectResponse> {
    return await HttpHelper.authGet(`/api/v1/users/projects/${id}`);
  }

  static async createProjectScene(projectUuid: string, data: IScene): Promise<ISceneResponse> {
    return await HttpHelper.post(`/api/v1/users/projects/${projectUuid}/scenes`, data);
  }

  static async deleteProject(projectUuid: string): Promise<ISceneResponse> {
    return await HttpHelper.delete(`/api/v1/users/projects/${projectUuid}`);
  }

  static async deleteProjectScene(projectUuid: string, sceneUuid: string): Promise<ISceneResponse> {
    return await HttpHelper.delete(`/api/v1/users/projects/${projectUuid}/scenes/${sceneUuid}`);
  }

  static async saveProjectScene(
    projectUuid: string,
    sceneUuid: string,
    data: Partial<IScene>,
  ): Promise<ISceneResponse> {
    return await HttpHelper.post(`/api/v1/users/projects/${projectUuid}/scenes/${sceneUuid}`, data);
  }

  static async saveProject(
    projectUuid: string,
    data: Partial<IProject>,
  ): Promise<ISceneResponse> {
    return await HttpHelper.post(`/api/v1/users/projects/${projectUuid}`, data, { background: true });
  }

  static async setProjectAsActive(projectUuid: string) {
    return await HttpHelper.post(`/api/v1/users/projects/${projectUuid}/activate`, {});
  }

  static async setSceneAsActive(projectUuid: string, sceneUuid: string) {
    return await HttpHelper.post(
      `/api/v1/users/projects/${projectUuid}/scenes/${sceneUuid}/activate`,
      {},
      {
        background: true,
      },
    );
  }

  static async getUserActiveProjectScene(uuid: string = null, sessionId: string = null): Promise<IProjectResponse> {
    return await HttpHelper.get(`/api/v1/users/overlay?verified=1${uuid ? `&uuid=${uuid}` : ''}${sessionId ? `&session_id=${sessionId}` : ''}`, { background: true });
  }

  static async getUserStreamSettings(): Promise<any> {
    return await HttpHelper.authGet('/api/v1/users/me/stream/settings', { background: true });
  }
}
